import { SIZE, COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';
import { Button } from '@app/src/common/Button';

const ROOT = 'Home/listProducts/ModalInterested';

export const Wrapper = styled.div`
  min-width: 290px;
  overflow-y: scroll;
  max-height: calc(100vh - 100px);
  background: #fff;
  border-radius: 8px;
  position: relative;
  padding: 30px 15px 24px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0px 60px 15px;
  }
`;

Wrapper.displayName = `${ROOT}/Wrapper`;

export const IconClose = styled.span`
  display: inline-block;
  background: ${COLORS.BLACK_BOLD};
  border-radius: 100%;
  width: 32px;
  height: 32px;
  top: 12px;
  right: 12px;
  cursor: pointer;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 42px;
    height: 42px;
  }
`;

IconClose.displayName = `${ROOT}/IconClose`;

export const FormWrapper = styled.form`
  max-width: 434px;
  
  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin: 45px auto 25px;
  }
`;

FormWrapper.displayName = `${ROOT}/FormWrapper`;

export const CheckboxText = styled.p`
  font-size: 11px;
  margin-left: 8px;

  a {
    color: ${COLORS.BLUE_LINK};
    font-family: ${FONTS.ROBOTO_BOLD};
    text-decoration: underline;
    font-size: 11px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;

    a {
      font-size: 13px;
    }
  }
`;

CheckboxText.displayName = `${ROOT}/CheckboxText`;

export const FieldWrapper = styled.div`
  margin-bottom: 16px;
`;

FieldWrapper.displayName = `${ROOT}/FieldWrapper`;

export const ButtonSend = styled(Button)`
  margin: 0 auto;
`;

export const Success = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15% 5%;
  text-align: center;
  max-width: 280px;
`;

Success.displayName = `${ROOT}/Success`;
